import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OrgResolverService implements Resolve<void> {
  constructor(private authService: AuthService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    const orgId = route.paramMap.get('orgId');
    if (!orgId) {
      return;
    }

    // A literal 'null'/'undefined' segment is the artifact of a link that was
    // built before the selected org had loaded. Repair the URL in place with
    // the org that's actually selected instead of treating it as an org the
    // user can't access (which raises a misleading error and bounces them).
    if (orgId === 'null' || orgId === 'undefined') {
      const selectedOrgId = this.authService.getSelectedOrgIdValue;
      if (selectedOrgId) {
        this.router.navigateByUrl(state.url.replace('/' + orgId, '/' + selectedOrgId), {
          replaceUrl: true,
        });
      } else {
        this.router.navigateByUrl('/main', { replaceUrl: true });
      }
      return;
    }

    this.authService.setOrgFromPath(orgId);
  }
}
